"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M17.5 7.93a2.5 2.5 0 00-2.45 2h-2.3l-4.01-4-.75.75 3.26 3.25h-6.3a2.5 2.5 0 100 1h6.3l-3.26 3.25.75.75 4.01-4h2.3a2.5 2.5 0 102.45-3z"];
//# sourceMappingURL=flows.js.map